// navigationConfig.ts
import About from "../components/About";
import ClientJobDetails from "../components/b2b/ClientJobDetails";
import CompanyDetails from "../components/b2b/CompanyDetails";
import CompanyList from "../components/b2b/CompanyList";
import CreateJob from "../components/b2b/CreateJob";
import JobsDashboard from "../components/b2b/JobsDashboard";
import LoginClient from "../components/b2b/LoginClient";
import ProfileSettings from "../components/b2b/ProfileSettings";
import UserList from "../components/b2b/UserList";
import VideoDetails from "../components/b2b/VideoDetails";
import LandingPage from "../components/dashboard/LandingPage";
import CompanyJobsDashboard from "../components/b2b/CompanyJobsDashboard";
import Reports from "../components/b2b/Reports";
import {
  ROUTE_CLIENT_JOB_DETAILS,
  ROUTE_CLIENT_LOGIN,
  ROUTE_COMPANY_DETAILS,
  ROUTE_COMPANY_EDIT,
  ROUTE_COMPANY_JOBS_DASHBOARD,
  ROUTE_COMPANY_LIST,
  ROUTE_COMPANY_NEW,
  ROUTE_CREATE_JOB,
  ROUTE_JOBS_DASHBOARD,
  ROUTE_MAIN,
  ROUTE_PROFILE_SETTINGS,
  ROUTE_USER_LIST,
  ROUTE_VIDEO_DETAILS,
  ROUTE_COMPANY_CREATE_JOB,
  ROUTE_COMPANY_JOB_DETAILS,
  ROUTE_REPORTS,
  ROUTE_SHARE_PROFILE,
} from "../constants/routes";
import ShareJobDetails from "../components/b2b/ShareJobDetails";

export const navigationConfig = [
  {
    path: "/about",
    roles: ["EMPLOYER_USER"],
    component: About,
  },
  {
    path: ROUTE_MAIN,
    roles: ["admin", "EMPLOYER_USER", "EMPLOYER_JOB_ADMIN"],
    component: LandingPage,
  },
  {
    path: ROUTE_CLIENT_LOGIN,
    roles: ["admin", "EMPLOYER_USER", "reviewer", "EMPLOYER_JOB_ADMIN"],
    component: LoginClient,
  },
  {
    path: ROUTE_JOBS_DASHBOARD,
    roles: ["admin"],
    component: JobsDashboard,
  },
  {
    path: ROUTE_COMPANY_JOBS_DASHBOARD,
    roles: ["admin"],
    component: CompanyJobsDashboard,
  },
  {
    path: `${ROUTE_COMPANY_JOB_DETAILS}/:jobId`,
    roles: ["admin"],
    component: ClientJobDetails,
  },
  {
    path: `${ROUTE_CLIENT_JOB_DETAILS}/:jobId`,
    roles: ["admin"],
    component: ClientJobDetails,
  },
  {
    path: ROUTE_COMPANY_LIST,
    roles: ["admin"],
    component: CompanyList,
  },
  {
    path: ROUTE_USER_LIST,
    roles: ["admin"],
    component: UserList,
  },
  {
    path: ROUTE_VIDEO_DETAILS,
    roles: ["admin", "reviewer"],
    component: VideoDetails,
  },
  // Employer-specific routes
  {
    path: ROUTE_CREATE_JOB,
    roles: ["admin", "EMPLOYER_JOB_ADMIN"],
    component: CreateJob,
  },
  {
    path: ROUTE_COMPANY_CREATE_JOB,
    roles: ["admin", "EMPLOYER_JOB_ADMIN"],
    component: CreateJob,
  },
  {
    path: ROUTE_COMPANY_DETAILS,
    roles: ["admin", "EMPLOYER_JOB_ADMIN"],
    component: CompanyDetails,
  },
  {
    path: ROUTE_COMPANY_NEW,
    roles: ["admin", "EMPLOYER_JOB_ADMIN"],
    component: CompanyDetails,
  },
  {
    path: ROUTE_COMPANY_EDIT,
    roles: ["admin", "EMPLOYER_JOB_ADMIN"],
    component: CompanyDetails,
  },
  {
    path: ROUTE_PROFILE_SETTINGS,
    roles: ["admin", "EMPLOYER_JOB_ADMIN"],
    component: ProfileSettings,
  },
  {
    path: ROUTE_REPORTS,
    roles: ["admin", "reviewer"],
    component: Reports,
  },
  {
    path: ROUTE_SHARE_PROFILE,
    roles: [], // Public route - no authentication required
    component: ShareJobDetails,
  },
  // Add more routes here
];
